import type { FaireProductEntity } from "../../entity_types/product";

export const p_5vp5kwc33v: FaireProductEntity = {
  token: "p_5vp5kwc33v",
  type: "product",
  name: "Bellevie 18K Gold Non-Tarnish Boho Gemstone Drop Earrings",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/b2f27e0397af05435f177e9a20a664063a8af752c82fccfe7dd439ea995b4768.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/371a0c0aeed65d039267bdb04ddd96574becb13a171bcf5d6546e4cb6b35f8af.jpeg",
    "https://cdn.faire.com/fastly/6f25e3a4195f901d1b665e521592e155cd5c954945222688cc3788495fc0c282.jpeg",
    "https://cdn.faire.com/fastly/d128f12cdd2f6b6ca0a540a08d0b213c661f0e26becbc5228fe89dc3470c0ce8.jpeg",
    "https://cdn.faire.com/fastly/5971e5eac476142efc21487ca41b18332574ff08a027ab2686d87fb55fff9df8.jpeg",
    "https://cdn.faire.com/fastly/81bf672bc326075f6934ca948b398b52bf781853f04cb8509e7a1ce4b7f3c741.jpeg",
  ],
  priceDollars: 23.56,
  description:
    "18K Gold Non-Tarnish Boho Gemstone Drop Earrings\n18K Gold Plating\nStainless Steel\nMeasurement (L x W inch): 0.43 x 2.35 \n \n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 47.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:38.681Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
